import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { StateUser } from '../state_user';

import { service_socketio_client } from '@/services/socketio_client_react/service_socketio_client';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';

export const remote_user_auth_logout = createAsyncThunkSafe<void, void>(ENUM__network_event_client_to_server.USER_AUTH_LOGOUT, async () => {
  await send_to_server(ENUM__network_event_client_to_server.USER_AUTH_LOGOUT);
});

export function init_remote_user_auth_logout(builder: ActionReducerMapBuilder<StateUser>) {
  builder.addCase(remote_user_auth_logout.pending, (state, action: PayloadAction) => {
    state.auth_token = '';
    service_socketio_client.is_connection_authorized = false;
  });
}
